import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdateRewardRequest from '../../../Spirit/Admin/Interfaces/Models/Reward/UpdateRewardRequest';
import SearchRewardRequest from '../../../Spirit/Admin/Interfaces/Models/Reward/SearchRewardRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import RewardResponse from '../../../Spirit/Admin/Interfaces/Models/Reward/RewardResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import RewardTriggerResponse from '../../../Spirit/Admin/Interfaces/Models/Reward/RewardTriggerResponse';

export default class RewardService {
	webApiService: WebApiService;
	UpdateRewardEvent = new Events<WsResponseModelT<Boolean>>();
	GetRewardEvent = new Events<WsResponseModelT<RewardResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<RewardResponse>>>();
	DeleteRewardEvent = new Events<WsResponseModelT<Boolean>>();
	GetRewardTriggersEvent = new Events<WsResponseModelT<Array<RewardTriggerResponse>>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('RewardService', 'UpdateReward', (res: WsResponseModelT<Boolean>) => {
			self.UpdateRewardEvent.trigger(res);
		});
		webApiService.on('RewardService', 'GetReward', (res: WsResponseModelT<RewardResponse>) => {
			self.GetRewardEvent.trigger(res);
		});
		webApiService.on('RewardService', 'GetList', (res: WsResponseModelT<PaginationResponseT<RewardResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('RewardService', 'DeleteReward', (res: WsResponseModelT<Boolean>) => {
			self.DeleteRewardEvent.trigger(res);
		});
		webApiService.on('RewardService', 'GetRewardTriggers', (res: WsResponseModelT<Array<RewardTriggerResponse>>) => {
			self.GetRewardTriggersEvent.trigger(res);
		});
		webApiService.on('RewardService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
	}
	UpdateReward(request: UpdateRewardRequest = null) { 	
        this.webApiService.send('RewardService', 'UpdateReward' , request);
    }
	GetReward(rewardId: number = 0) { 	
        this.webApiService.send('RewardService', 'GetReward' , rewardId);
    }
	GetList(request: SearchRewardRequest = null) { 	
        this.webApiService.send('RewardService', 'GetList' , request);
    }
	DeleteReward(rewardId: number = 0) { 	
        this.webApiService.send('RewardService', 'DeleteReward' , rewardId);
    }
	GetRewardTriggers() { 	
        this.webApiService.send('RewardService', 'GetRewardTriggers' );
    }
	ChangeSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('RewardService', 'ChangeSortIndex' , request);
    }
	 // async methods
	async updateRewardAsync(request: UpdateRewardRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateReward.bind(this), this.UpdateRewardEvent)(request);
	}
	async getRewardAsync(rewardId: number = 0): Promise<RewardResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetReward.bind(this), this.GetRewardEvent)(rewardId);
	}
	async getListAsync(request: SearchRewardRequest = null): Promise<PaginationResponseT<RewardResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async deleteRewardAsync(rewardId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteReward.bind(this), this.DeleteRewardEvent)(rewardId);
	}
	async getRewardTriggersAsync(): Promise<Array<RewardTriggerResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetRewardTriggers.bind(this), this.GetRewardTriggersEvent)();
	}
	async changeSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
}